<template lang="pug">
  .jumbo(:class="theme")
    .bg
      img(v-if="img" :src="img", alt="")
      VideoPlayer(v-if="video", :video="video", :poster="poster")
    .content
      h1.logo
        img(v-if="logo" :src="logo", alt="")
      h2.title(v-if="title") {{title}}
      h3(v-if="undertitle") {{undertitle}}
      h3(v-if="extra") {{extra}}
      ArrowButton.arrow(v-if="more", text="continuar", direction="down")

</template>
<script>
import VideoPlayer from '@/components/VideoPlayer'
import ArrowButton from '@/components/ArrowButton'

export default {
  props: {
    logo: String,
    img: String,
    undertitle: String,
    title: String,
    video: String,
    extra: String,
    poster: String,
    theme: String,
    more: Boolean
  },
  components: {
    VideoPlayer,
    ArrowButton
  }
}
</script>

<style lang="scss" scoped>
  .logo{
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
    img{
      max-height: 25vh;
      @media screen and (orientation:portrait) {
        // max-height: none;
      }
    }
  }
  h3{
    @include fluid-type(360px,
  1440px,
  18px,
  28px);
    text-align: center;
    margin-bottom: 2rem;
    color: white;
    .theme-black &{
      color: black;
    }
    small{
      display: block;
    }
  }
  .jumbo{
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    color: white;
    overflow: hidden;
    &.theme-black{
      color: black;
    }
    .bg{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      // &:after{
      //   content:  '';
      //   position: absolute;
      //   height: 60vh;
      //   left: 0;
      //   right: 0;
      //   bottom: 0;
      //   background: linear-gradient(transparent, rgba(0,0,0,1));
      //   mix-blend-mode: multiply;
      // }
    }
    .content{
      position: relative;
      z-index: 2;
      max-width: 50vw;
      text-align: center;
      padding: 1rem;
      margin-left: auto;
      margin-right: auto;
      @media (max-width: 800px){
        max-width: 90vw;
      }
    }
    height: 80vh;
  }
</style>
